import { IntentCaptureScreen } from '@/features/setup/screens';
export default IntentCaptureScreen;
